import { useMemo } from 'react';

const useSortedCenters = (centers) => {
  return useMemo(() => {
    if (!centers) return [];

    return [...centers].sort((a, b) => {
      const aName = a.name.trim().toLowerCase();
      const bName = b.name.trim().toLowerCase();

      if (aName.startsWith("content") && bName.startsWith("content")) {
        return aName.localeCompare(bName);
      } else if (aName.startsWith("content")) {
        return -1;
      } else if (bName.startsWith("content")) {
        return 1;
      } else if ((aName.startsWith("test") || aName.startsWith("tester")) && (bName.startsWith("test") || bName.startsWith("tester"))) {
        return aName.localeCompare(bName);
      } else if (aName.startsWith("test") || aName.startsWith("tester")) {
        return -1;
      } else if (bName.startsWith("test") || bName.startsWith("tester")) {
        return 1;
      } else {
        return aName.localeCompare(bName);
      }
    });
  }, [centers]);
};

export default useSortedCenters;